import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import ToolboxApp from './tools/ToolboxApp';
import { installUsageAnalytics } from './lib/usageAnalytics';

const root = document.getElementById('root')!;
root.replaceChildren();
installUsageAnalytics();
createRoot(root).render(<StrictMode><ToolboxApp /></StrictMode>);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}
